<head><link id="loadOverlay" rel='stylesheet' type='text/css' href='https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/scripts/survey-dev.min.css'/>  </head>

<div id="selectedLayout" [innerHtml]="selectedLayout | safeHtml"></div>